import JsTypeInspector from '../../serviceLayer/validators/JsTypeInspector';
import LocalStorageHelper from './LocalStorageHelper';
import JsonObjectInspector from '../../serviceLayer/validators/JsonObjectInspector';



const setItemInLocalStorage = function(key, value){
    if(JsTypeInspector.isTypeString(key) && (value)) {
        //console.log("setItemInLocalStorage-key", key);
        //console.log("setItemInLocalStorage-value", value);
        const valueString = JSON.stringify(value);

        //console.log("setItemInLocalStorage-JSON.stringify()-valueString", valueString);
        LocalStorageHelper.setItemStorage(key, valueString);

        return 'OK';
    }
    return null;
}

const getItemFromLocalStorage = function(key){
    if (JsTypeInspector.isTypeString(key) ) {
        const itemString = LocalStorageHelper.getItemStorage(key);
        const itemObject = JsonObjectInspector.safeJsonParse(itemString);

        return itemObject;
    }

    return null;
}

const removeItemFromLocalStorage = function(key ){
    if (JsTypeInspector.isTypeString(key) ) {
        const removed = LocalStorageHelper.removeItemStorage (key);
        
        return removed;
    }

    return null;
}

const clearAllItemsFromLocalStorage = function(){
    LocalStorageHelper.clearAllItemsStorage();
}

const getItemKeyFromLocalStorage = function(index){
    let result = LocalStorageHelper.getKeyNameStorage(index);
    return result;
}


const LocalStorageDataStorer = Object.freeze({
    setItemInLocalStorage : setItemInLocalStorage,
    getItemFromLocalStorage : getItemFromLocalStorage,
    getItemKeyFromLocalStorage : getItemKeyFromLocalStorage,
    removeItemFromLocalStorage : removeItemFromLocalStorage,
    clearAllItemsFromLocalStorage : clearAllItemsFromLocalStorage
});


export default LocalStorageDataStorer;